import React from "react";
import Typography from "@material-ui/core/Typography";

export function PipeSeparator() {
  return <Typography variant="h4">|&nbsp;</Typography>;
}
